// Mock data for 1min.ai clone

export const mockAIProviders = [
  {
    id: 'gpt4',
    name: 'GPT-4',
    provider: 'OpenAI',
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/openai/openai-original.svg',
    enabled: true,
    apiKeyConfigured: false,
    description: 'Most capable GPT-4 model'
  },
  {
    id: 'claude',
    name: 'Claude 3',
    provider: 'Anthropic',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/7/78/Anthropic_logo.svg',
    enabled: true,
    apiKeyConfigured: false,
    description: 'Anthropic\'s advanced AI assistant'
  },
  {
    id: 'gemini',
    name: 'Gemini Pro',
    provider: 'Google AI',
    logo: 'https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg',
    enabled: true,
    apiKeyConfigured: false,
    description: 'Google\'s multimodal AI model'
  },
  {
    id: 'llama',
    name: 'Llama 3',
    provider: 'Meta',
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/meta/meta-original.svg',
    enabled: false,
    apiKeyConfigured: false,
    description: 'Meta\'s open-source language model'
  },
  {
    id: 'mistral',
    name: 'Mistral',
    provider: 'Mistral AI',
    logo: 'https://mistral.ai/images/logo_hubc88c4ece131b91c7cb753f40e9e1cc5_2589_256x0_resize_q97_h2_lanczos_3.webp',
    enabled: false,
    apiKeyConfigured: false,
    description: 'Efficient open-weight model'
  },
  {
    id: 'cohere',
    name: 'Command R+',
    provider: 'Cohere',
    logo: 'https://cohere.com/favicon.ico',
    enabled: false,
    apiKeyConfigured: false,
    description: 'Enterprise-grade language model'
  }
];

export const mockChatHistory = [
  {
    id: '1',
    timestamp: new Date().toISOString(),
    question: 'What is the future of AI?',
    responses: [
      {
        providerId: 'gpt4',
        response: 'The future of AI is incredibly promising. We\'re seeing rapid advancement in multimodal AI, better reasoning capabilities, and more efficient models. Key trends include: 1) AI becoming more accessible 2) Better human-AI collaboration 3) Ethical AI development 4) Domain-specific AI solutions.',
        timestamp: new Date().toISOString()
      },
      {
        providerId: 'claude',
        response: 'AI\'s future will be shaped by several factors: Enhanced reasoning and planning abilities, improved safety and alignment, integration across industries, and democratization of AI tools. We\'ll likely see AI become a collaborative partner rather than just a tool.',
        timestamp: new Date().toISOString()
      },
      {
        providerId: 'gemini',
        response: 'The future of AI involves multimodal understanding, real-time learning, and seamless integration into daily life. Expect advances in healthcare, education, scientific research, and creative tools. Responsible development will be crucial.',
        timestamp: new Date().toISOString()
      }
    ]
  }
];

export const mockFeatures = [
  { icon: 'MessageSquare', label: 'AI Chat', description: 'Multi-model conversations' },
  { icon: 'Wand2', label: 'Image Gen', description: 'AI-powered images' },
  { icon: 'Image', label: 'Image Edit', description: 'Enhance & modify' },
  { icon: 'FileText', label: 'Document', description: 'PDF & text analysis' },
  { icon: 'Mic', label: 'Audio', description: 'Speech & transcription' },
  { icon: 'Video', label: 'Video', description: 'Video generation' },
  { icon: 'Users', label: 'Team', description: 'Collaboration tools' }
];

export const mockResponses = {
  gpt4: "I'm GPT-4, OpenAI's most advanced model. I can help with complex reasoning, creative writing, analysis, and much more. How can I assist you today?",
  claude: "Hello! I'm Claude, created by Anthropic. I'm designed to be helpful, harmless, and honest. I excel at detailed analysis and thoughtful conversations. What would you like to explore?",
  gemini: "Hi! I'm Gemini Pro from Google. I'm a multimodal AI that can understand and generate text, process images, and assist with various tasks. What can I help you with?",
  llama: "Hey! I'm Llama 3 from Meta. As an open-source model, I bring powerful AI capabilities to everyone. Let's chat!",
  mistral: "Bonjour! I'm Mistral, an efficient and powerful language model. I'm here to help with your questions and tasks.",
  cohere: "Hello! I'm Command R+ from Cohere, optimized for enterprise use cases. I can help with RAG, analysis, and complex reasoning tasks."
};